var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container",attrs:{"id":"wrapper"}},[_c('div',{staticClass:"page-msg-success"},[_vm._v("新手机号码更改成功")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-gray btn-l",attrs:{"to":"/student/user/center"}},[_vm._v("返回")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ad6fcf0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/student/user/phone-succeed.vue
// module id = null
// module chunks = 